export const useLogger = () => {
    // @ts-expect-error
    const { NODE_ENV } = import.meta.client;
    if (NODE_ENV !== 'development') {
        console.warn('useLogger will not show any console messages in production environments');
    }
    const _log = (message, type = 'log', ...params) => {
        if (NODE_ENV !== 'development')
            return;
        if (typeof console[type] === 'function') {
            console[type](message, params);
        }
        else {
            console.log(message, params);
        }
    };
    const log = (message, ...params) => _log(message, 'log', ...params);
    const info = (message, ...params) => _log(message, 'info', ...params);
    const warn = (message, ...params) => _log(message, 'warn', ...params);
    const error = (message, ...params) => _log(message, 'error', ...params);
    return {
        log,
        info,
        warn,
        error,
    };
};
